export default __webpack_public_path__ + "static/media/girl_night.daed9a89.png";